module.exports = __webpack_public_path__ + "static/img/fib.c2843afd.png";